const GLOBALVAR = {
  SERVER_ROOT: 'https://api.petruspaulus.com' // live
  //SERVER_ROOT: 'http://localhost:5002' // localhost
};

export default GLOBALVAR;